// src/utils/firebase/fetchLatestMetadata.js
import {
  getBytes,
  getStorage,
  list,
  ref,
} from "firebase/storage";
import { firebaseApp } from "../../firebase/firebaseApp";
import { isNewerMetadataName } from "./metadataFilename";

const MAX_METADATA_BYTES = 2 * 1024 * 1024;

export async function fetchLatestMetadata(uid) {
  const storage = getStorage(firebaseApp);
  const dirRef = ref(storage, `user_metadata/${uid}`);

  let pageToken = undefined;
  let newestRef = null;

  do {
    // eslint-disable-next-line no-await-in-loop
    const res = await list(dirRef, { maxResults: 1000, pageToken });

    for (const item of res.items) {
      if (!newestRef || isNewerMetadataName(item.name, newestRef.name)) {
        newestRef = item;
      }
    }

    pageToken = res.nextPageToken;
  } while (pageToken);

  if (!newestRef) return null;

  // Use the authenticated SDK path so reads continue to work under strict
  // Storage rules; this also avoids the tokenised public URL fetch.
  const bytes = await getBytes(newestRef, MAX_METADATA_BYTES);
  const text = new TextDecoder("utf-8").decode(bytes);

  const json = JSON.parse(text);
  return json.responses ?? json;
}
